var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#506D85",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.5,
    d: "M19.406 15.306v4.188c0 1.488-1.201 2.698-2.677 2.698H4.952c-1.476 0-2.677-1.21-2.677-2.698V7.619c0-1.488 1.201-2.7 2.677-2.7h4.47c.37 0 .67.303.67.676 0 .372-.3.674-.67.674h-4.47c-.738 0-1.339.606-1.339 1.35v11.875c0 .744.6 1.349 1.339 1.349h11.777c.738 0 1.338-.605 1.338-1.35v-4.187c0-.372.3-.674.67-.674.369 0 .669.302.669.674zm2.04-9.43a.67.67 0 0 1 0 .952l-2.683 2.689a.679.679 0 0 0-.003.954.664.664 0 0 0 .946.003l2.684-2.689c.382-.383.592-.892.592-1.433 0-.542-.21-1.05-.592-1.433l-2.684-2.69a.665.665 0 0 0-.946.004.679.679 0 0 0 .003.954l2.683 2.689zm-1.442.444c0-.373-.3-.675-.67-.675a8.937 8.937 0 0 0-6.387 2.668 9.087 9.087 0 0 0-2.646 6.44v.507c0 .372.3.674.67.674.369 0 .669-.302.669-.674v-.507c0-4.278 3.452-7.759 7.695-7.759.37 0 .669-.302.669-.674z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportDashboard);
export default __webpack_public_path__ + "static/media/export-dashboard.44114d8d01fa9692793a3be2c2a3dde0.svg";
export { ForwardRef as ReactComponent };